var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1981",
    "data-name": "Path 1981",
    d: "M13.556,6.556,12.3,7.809l2.293,2.3H6.661v1.778H14.6L12.3,14.182l1.253,1.262L18,11ZM3.778,4.778h7.111V3H3.778A1.783,1.783,0,0,0,2,4.778V17.222A1.783,1.783,0,0,0,3.778,19h7.111V17.222H3.778Z",
    transform: "translate(-2 -3)",
    fill: "#c32519"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.07a2152b7ad8df185dad866610aae0c4.svg";
export { ForwardRef as ReactComponent };